// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"21":"8f8c17cc","31":"1a019b62","36":"5310103f","69":"05e2d101","124":"fe270de0","381":"a80c91f7","384":"6ab6b586","443":"8f6a4818","477":"78e68a27","548":"348b99e9","585":"382f4ed0","706":"65441ddc","810":"dd963fbd","965":"072b5c35"}[chunkId] + ".chunk.js";
};